import { Helmet } from 'react-helmet-async';

interface LocalBusinessSchemaProps {
  city: string;
  latitude: number;
  longitude: number;
}

export function LocalBusinessSchema({ city, latitude, longitude }: LocalBusinessSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: `Fractional CISO Services in ${city}`,
    description: `Cybersecurity leadership for ${city}`,
    url: `https://thecisonetwork.com/gb/${city.toLowerCase()}`,
    provider: {
      '@type': 'Organization',
      name: 'The CISO Network',
    },
    areaServed: {
      '@type': 'City',
      name: city,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude,
      longitude,
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
